type Device = {
  title: string;
  url: string;
  price: { value: number };
  thumbUrl: string;
  isPreorder: boolean;
  isOutOfStock: boolean;
};

export const generateCatalogMarkup = (products: Device[]) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: products.map((product, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'Product',
      name: product.title,
      image: `https:${product.thumbUrl}`,
      offers: {
        '@type': 'Offer',
        price: product.price.value,
        priceCurrency: 'RUB',
        availability:
          (product.isPreorder && 'https://schema.org/PreOrder') ||
          (product.isOutOfStock && 'https://schema.org/OutOfStock') ||
          'https://schema.org/InStock',
      },
    },
  })),
});
